import script from "./DemoForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemoForm.vue?vue&type=script&setup=true&lang=ts"

import "./DemoForm.vue?vue&type=style&index=0&id=3ea3785d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea3785d"]])

export default __exports__